import { Popover } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import MobMenuCloseIcon from './Icons/MobMenuCloseIcon'
import MobMenuIcon from './Icons/MobMenuIcon'
import NavItems from './NavItems'
import { getNavItems } from './nav_items'

const NavItemsMob = () => {
  const { t } = useTranslation()
  const menuContainerRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const openMenu = Boolean(anchorEl)
  const handleOpenMenu = (e) => {
    setAnchorEl(menuContainerRef.current)
  }
  const handleCloseMenu = (e) => {
    setAnchorEl(null)
  }

  const { pathname } = useLocation()
  const { shortTitle = '', title = '' } = getNavItems(t).find((i) => i.url === pathname) || {}
  const currentItemTitle = shortTitle || title

  useEffect(() => {
    handleCloseMenu()
  }, [pathname])

  return (
    <div className="nav_items_mob" ref={menuContainerRef}>
      {!openMenu ? (
        <MobMenuIcon handler={handleOpenMenu} />
      ) : (
        <MobMenuCloseIcon handler={handleCloseMenu} />
      )}
      <span className="current_nav_item">{currentItemTitle}</span>

      <Popover
        open={openMenu}
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        container={menuContainerRef.current}
        className="menu_popover"
        slotProps={{ paper: { className: 'menu_paper' } }}
      >
        <NavItems />
      </Popover>
    </div>
  )
}

export default NavItemsMob
